import React, { useState } from "react";
import { Button, CircularProgress, Dialog } from "@mui/material";
import styles from "../../../../Tasks/components/Tasks.module.css";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import Right from "../../../../../../assets/images/Automation.svg";

function FinalConfirmPopup(props: any) {
  const {
    handlePopupYesButton,
    handlePopupNoButton,
    loading,
    isOpen,
    setIsOpen,
    textForReminder,
    fields,
    saveLeadAutomationConfigLoading,
    editLeadAutomationConfigLoading,
  } = props;

  const mapAutomationToUI = (fields: any[]) => {
    const getField = (name: string) =>
      fields.find((x) => x.fieldName === name)?.selectedOption;

    const getValue = (name: string) => {
      const val = getField(name);

      if (!val) return "-";

      // MULTI SELECT (Assignee)
      if (Array.isArray(val)) {
        return val.length > 0 ? val.map((d: any) => d.name).join(", ") : "-";
      }

      // OBJECT VALUES (Source, Course, Branch, Batch)
      if (typeof val === "object") {
        return (
          val?.sourceName ||
          val?.courseName ||
          val?.branchName ||
          val?.batchName ||
          val?.name ||
          "-"
        );
      }

      // STRING VALUES (Trigger, Assignee Method, etc.)
      return val || "-";
    };

    const methodLabel = getValue("Assignee Method");
    const assigneeValue = getValue("Assignee");

    return [
      { label: "Triger", value: getValue("Trigger") },
      { label: "Source", value: getValue("Source") },
      { label: "Course", value: getValue("Course") },
      { label: "Branch", value: getValue("Branch") },
      { label: "Batch", value: getValue("Batch") },
      {
        label: "Assignment",
        value: `${methodLabel} - ${assigneeValue}`,
      },
    ];
  };

  return (
    <Dialog
      open={isOpen}
      sx={{
        zIndex: "9999999",
        minWidth: "414px",
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "600px",
          maxHeight: "500px",
          minHeight: "155px",
          padding: "34px",
          borderRadius: "8px",
          boxShadow:
            "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
          // left: "10%",
          background: "#FFFFFF",
          overflow: "hidden",
        },
      }}
    >
      <div className={styles.deactivationPopup}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            // gap: "20px",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              cursor: "pointer",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <CloseIcon
              onClick={() => {
                setIsOpen(false);
              }}
              style={{
                pointerEvents: loading ? "none" : "auto",
                opacity: loading ? 0.5 : 1,
                cursor: loading ? "not-allowed" : "pointer",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                marginBottom: "10px",
                gap: "10px",
              }}
            >
              <div>
                <img src={Right} />
              </div>
              <div>
                <div className={styles.popupHead}>
                  Confirm Auto Assignment Setup
                </div>
                <div className={styles.popupSubHead}>
                  Your auto assignment configuration:
                </div>
              </div>
            </div>
            <div
              style={{
                backgroundColor: "rgba(17, 200, 155, 0.05)",
                borderRadius: "6px",
                padding: "16px 20px",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                width: "100%",
              }}
            >
              {mapAutomationToUI(fields).map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "160px auto",
                    alignItems: "center",
                    fontSize: "15px",
                  }}
                >
                  <div
                    style={{
                      color: "rgba(20, 44, 68, 1)",
                      fontWeight: 500,
                    }}
                  >
                    {item.label}
                  </div>
                  <div
                    style={{
                      color: "rgba(102, 112, 133, 1)",
                      fontWeight: 400,
                    }}
                  >
                    : {item.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={styles.popupButtonDiv}>
          <Button
            sx={{
              textTransform: "capitalize",
              backgroundColor: "#ffffff",
              color: "#344054",
              border: "1px solid #D0D5DD",
            }}
            onClick={() => {
              handlePopupNoButton();
              setIsOpen(false);
            }}
            fullWidth
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            sx={{
              textTransform: "capitalize",
              backgroundColor: "rgba(17, 200, 155, 1)",
              color: "#ffffff",
              "&:hover": {
                backgroundColor: "rgba(17, 200, 155, 1)",
              },
            }}
            onClick={() => {
              handlePopupYesButton();
              // setIsOpen(false);
            }}
            fullWidth
            disabled={loading}
          >
            {/* Yes */}
            {saveLeadAutomationConfigLoading ||
            editLeadAutomationConfigLoading ? (
              <CircularProgress size={18} color={"inherit"} />
            ) : (
              "Confirm Setup"
            )}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

export default FinalConfirmPopup;
